<script lang="ts" setup></script>

<template>
  <span>
    <span :class="$style.title__dots">NISA</span>に関する<br />
    こんなお悩みが解決できます
  </span>
</template>

<style lang="scss" module>
.title {
  &__dots {
    -webkit-text-emphasis: filled $color-surface-accent-primary;
    text-emphasis: filled $color-surface-accent-primary;
  }
}
</style>
